import { Injectable } from '@angular/core';
import { IAuthenticationStorage } from '@nimbus-library/features/authentication/services/i-authentication-storage';
import { IUserInfo } from '@nimbus-library/features/menu/models/i-user.info';

@Injectable({ providedIn: 'root' })
export class WallboardAuthenticationStorageService extends IAuthenticationStorage {
  public saveAuthData(): void {}

  public clearAuthData(): void {}

  public getUserInfo(): IUserInfo {
    return null;
  }

  public saveTeamsInfo(): void {}

  public getTeamsInfo(): string {
    return null;
  }
}
